<div class="flex flex-column min-h-screen justify-content-stretch align-items-stretch">
  <app-header></app-header>

  <div class="flex-grow-1">
    <router-outlet></router-outlet>
  </div>
</div>
